// extracted by mini-css-extract-plugin
module.exports = {"button":"ApplePayButton_button__DDYnx","roundedCorners":"ApplePayButton_roundedCorners__h_EGt","logo":"ApplePayButton_logo__NQuS4","text":"ApplePayButton_text__DefXD"};